import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  hasSelectedWorkspaceFromUrlGuard,
  hasSelectedWorkspaceGuard,
  selectWorkspaceFromRouteGuard,
} from '@mkp/auth/feature-guards';
import { isNavigationEnd } from '@mkp/shared/util-router';
import { filter, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { isRouteProtectedByGuard } from './auth-effects.helpers';

@Injectable({ providedIn: 'root' })
export class NavigationTrackerService {
  private router = inject(Router);
  private navigationEndEvents$ = this.router.events.pipe(filter(isNavigationEnd));
  private navigationEndSubject$ = new ReplaySubject<NavigationEnd>(1);

  public isUnguardedNavigationEnd$ = this.navigationEndSubject$
    .asObservable()
    .pipe(filter(() => !this.isCurrentRouteGuarded()));

  constructor() {
    this.navigationEndEvents$.pipe(take(1)).subscribe(this.navigationEndSubject$);
  }

  private isCurrentRouteGuarded() {
    return isRouteProtectedByGuard(this.router.routerState.snapshot.root, [
      hasSelectedWorkspaceFromUrlGuard,
      hasSelectedWorkspaceGuard,
      selectWorkspaceFromRouteGuard,
    ]);
  }
}
